import { useMutation } from '@apollo/client/react'
import { Button, notification } from 'antd'
import Hotkeys from 'react-hot-keys'

import { UpdateDocumentPaymentMetadataDocument } from '~app/graph/generated/graphql'
import i18n from '~app/i18n/i18n'

notification.config({ placement: 'bottomRight' })

interface Props {
  documentId: string
  onDone?: () => any
}

export async function clearMetadata(
  documentId: Props['documentId'],
  updatePaymentMetadata: Function,
  onDone?: Props['onDone']
) {
  try {
    const result = await updatePaymentMetadata({
      variables: {
        documentId,
        data: {
          amount: null,
          iban: null,
          recipient: null,
          reference: null,
        },
      },
    })
    if (result && result.errors) {
      const [error] = result.errors
      notification.error({
        message: i18n.t('misc.error'),
        description: error.message,
      })
    } else if (onDone) {
      onDone()
    }
  } catch (error) {
    notification.error({
      message: i18n.t('misc.error'),
      description: error.message || i18n.t('misc.error'),
    })
  }
}

const ClearPaymentMetadataButton = ({ documentId, onDone }: Props) => {
  const [updatePaymentMetadata] = useMutation(
    UpdateDocumentPaymentMetadataDocument
  )
  return (
    <Hotkeys
      keyName="shift+w"
      onKeyDown={() => clearMetadata(documentId, updatePaymentMetadata, onDone)}
    >
      <Button
        type="primary"
        danger
        block
        onClick={() => clearMetadata(documentId, updatePaymentMetadata, onDone)}
      >
        {i18n.t('documentView.clearPayment')}
      </Button>
    </Hotkeys>
  )
}

export default ClearPaymentMetadataButton
